const periodontology = {
  hero: {
    topLine: "Εξειδικευμένοι Οδοντίατροι",
    titleLine1: "Σύγχρονη Περιοδοντολογία",
    titleLine2: "για Υγιή Ούλα",
    description:
      "Οι εξειδικευμένες περιοδοντικές θεραπείες μας αντιμετωπίζουν αποτελεσματικά τα προβλήματα των ούλων και προάγουν τη στοματική υγεία με προηγμένες, ελάχιστα επεμβατικές τεχνικές.",
    ctas: {
      primary: "Κλείσε Ραντεβού",
      secondary: "Μάθε Περισσότερα",
    },
    imageAlt: "Advanced Periodontal Treatment",
    stats: {
      value: "98%",
      label: "Ποσοστό Επιτυχίας",
    },
    floatingLabel: "Αποκατάσταση Ούλων",
  },
  benefits: {
    heading: "ΓΙΑΤΙ ΝΑ ΕΠΙΛΕΞΕΤΕ ΤΗΝ ΠΕΡΙΟΔΟΝΤΙΚΗ ΜΑΣ ΦΡΟΝΤΙΔΑ",
    intro:
      "Ζήστε ολοκληρωμένες περιοδοντικές θεραπείες με έμφαση στην πρόληψη και τη μακροχρόνια υγεία των ούλων.",
    items: [
      {
        title: "Πρόληψη Ουλίτιδας & Περιοδοντίτιδας",
        description:
          "Οι θεραπείες μας βοηθούν στην πρόληψη και διαχείριση της περιοδοντίτιδας, προστατεύοντας τα δόντια από απώλεια και διατηρώντας το χαμόγελό σας.",
      },
      {
        title: "Βελτίωση Συνολικής Υγείας",
        description:
          "Η καλή υγεία των ούλων συμβάλλει σε καλύτερη γενική υγεία μειώνοντας τη φλεγμονή και τον κίνδυνο βακτηριακών λοιμώξεων.",
      },
      {
        title: "Έγκαιρη Διάγνωση",
        description:
          "Εντοπίζουμε και αντιμετωπίζουμε περιοδοντικά προβλήματα εγκαίρως, προλαμβάνοντας την εξέλιξη σε πιο σοβαρές καταστάσεις.",
      },
    ],
  },
  process: {
    heading: "Η ΔΙΑΔΙΚΑΣΙΑ ΠΕΡΙΟΔΟΝΤΙΚΗΣ ΘΕΡΑΠΕΙΑΣ ΜΑΣ",
    intro:
      "Μια συστηματική προσέγγιση για τη διάγνωση και θεραπεία περιοδοντικών παθήσεων για βέλτιστη υγεία των ούλων",
    stepLabel: "Βήμα",
    items: [
      {
        title: "Ολοκληρωμένη Αξιολόγηση",
        description:
          "Λεπτομερής εξέταση των ούλων, μέτρηση του βάθους των θυλάκων και έλεγχος για φλεγμονή και αιμορραγία.",
      },
      {
        title: "Διάγνωση & Σχεδιασμός",
        description:
          "Ακριβής διάγνωση της περιοδοντικής σας κατάστασης και δημιουργία εξατομικευμένου πλάνου θεραπείας.",
      },
      {
        title: "Εξειδικευμένη Θεραπεία",
        description:
          "Προηγμένες περιοδοντικές θεραπείες, όπως καθαρισμός, απόξεση ριζών και χρήση laser όπου απαιτείται.",
      },
      {
        title: "Συντήρηση & Παρακολούθηση",
        description:
          "Τακτικοί επανέλεγχοι και φροντίδα συντήρησης για να εξασφαλιστεί η μακροχρόνια υγεία των ούλων και να προληφθεί η υποτροπή.",
      },
    ],
  },
  faq: {
    heading: "ΣΥΧΝΕΣ ΕΡΩΤΗΣΕΙΣ",
    intro:
      "Απαντήσεις σε συχνές ερωτήσεις σχετικά με την περιοδοντική υγεία και τις θεραπείες",
    items: [
      {
        question: "Τι είναι η περιοδοντική νόσος;",
        answer:
          "Η περιοδοντική νόσος, γνωστή και ως περιοδοντίτιδα, είναι μια μόλυνση των ιστών που συγκρατούν τα δόντια στη θέση τους. Συνήθως προκαλείται από κακές συνήθειες βουρτσίσματος και χρήσης οδοντικού νήματος, που επιτρέπουν στη μικροβιακή πλάκα να συσσωρευτεί και να σκληρύνει.",
      },
      {
        question: "Ποια είναι τα σημάδια της ουλίτιδας;",
        answer:
          "Συχνά σημάδια περιλαμβάνουν κόκκινα, πρησμένα ή ευαίσθητα ούλα, αιμορραγία κατά το βούρτσισμα ή τη χρήση νήματος, υποχώρηση των ούλων, επίμονη κακοσμία, κινητικότητα δοντιών και αλλαγές στη σύγκλειση των δοντιών.",
      },
      {
        question: "Είναι επώδυνη η περιοδοντική θεραπεία;",
        answer:
          "Οι περισσότερες περιοδοντικές θεραπείες πραγματοποιούνται με τοπική αναισθησία για να εξασφαλιστεί η άνεσή σας. Σε πιο εκτεταμένες περιπτώσεις προσφέρονται επιλογές ολικής αναισθησίας. Η μετεγχειρητική ενόχληση είναι συνήθως ελαφριά και αντιμετωπίζεται με κοινά παυσίπονα.",
      },
      {
        question: "Πόσο διαρκεί η περιοδοντική θεραπεία;",
        answer:
          "Η διάρκεια εξαρτάται από τη σοβαρότητα της κατάστασης. Οι αρχικές θεραπείες μπορεί να απαιτούν 1-2 επισκέψεις, ενώ πιο προχωρημένες περιπτώσεις ίσως χρειαστούν θεραπείες που εκτείνονται σε εβδομάδες ή μήνες. Οι επισκέψεις συντήρησης γίνονται συνήθως κάθε 3-4 μήνες.",
      },
      {
        question: "Μπορεί να αντιστραφεί η ουλίτιδα;",
        answer:
          "Η πρώιμη ουλίτιδα (gingivitis) μπορεί να αντιστραφεί με επαγγελματική θεραπεία και σωστή στοματική υγιεινή. Η προχωρημένη περιοδοντίτιδα δεν μπορεί να αναστραφεί πλήρως, αλλά μπορεί να αντιμετωπιστεί αποτελεσματικά ώστε να σταματήσει η εξέλιξή της.",
      },
      {
        question: "Σχετίζεται η περιοδοντική νόσος με άλλα προβλήματα υγείας;",
        answer:
          "Ναι, έρευνες έχουν δείξει σύνδεση μεταξύ της περιοδοντικής νόσου και διαφόρων συστηματικών παθήσεων, όπως καρδιοπάθειες, διαβήτης, αναπνευστικά προβλήματα και επιπλοκές στην εγκυμοσύνη. Η υγεία των ούλων συμβάλλει στη γενική σας υγεία.",
      },
    ],
  },
};

export default periodontology;

